export default __webpack_public_path__ + "static/media/Timer.32c2a979.png";